<template>
  <div>
    <NavBar msg="历史成交"></NavBar>
    <div class="content">
      <van-tabs v-model="active" @click="tabClick()">
        <van-tab title="近7日">
          <div class="main-centent">
            <div class="todaySelected-title">
              <div style="width: 2.08rem">股票/时间</div>
              <div style="width: 1.8rem">成交价</div>
              <div style="width: 1.3rem">成交量</div>
              <div style="width: 1.65rem; text-align: right" @click="zfClick()">
                <span>成交额</span>
              </div>
            </div>
          </div>
          <van-pull-refresh v-model="isLoading" @refresh="onRefresh">
            <van-list v-model="loading" :finished="finished" @load="onLoad">
              <CJList
                v-if="active == 0 && list.length > 0"
                :list="list"
              ></CJList>
              <div v-else class="wushuju" v-show="show">
                <img src="../assets/wushuju.png" alt="" />
                <p>暂无数据</p>
              </div>
            </van-list>
          </van-pull-refresh>
        </van-tab>
        <van-tab title="近30日">
          <div class="main-centent">
            <div class="todaySelected-title">
              <div style="width: 2.08rem">股票/时间</div>
              <div style="width: 1.8rem">成交价</div>
              <div style="width: 1.3rem">成交量</div>
              <div style="width: 1.65rem; text-align: right" @click="zfClick()">
                <span>成交额</span>
              </div>
            </div>
          </div>
          <van-pull-refresh v-model="isLoading" @refresh="onRefresh">
            <van-list v-model="loading" :finished="finished" @load="onLoad">
              <CJList
                v-if="active == 1 && list.length > 0"
                :list="list"
              ></CJList>
              <div v-else class="wushuju" v-show="show">
                <img src="../assets/wushuju.png" alt="" />
                <p>暂无数据</p>
              </div>
            </van-list>
          </van-pull-refresh>
        </van-tab>
        <van-tab title="自定义">
          <div class="calendar">
            <div class="left">
              <span @click="startClick"
                >{{ startDate }} <img src="../assets/rl.png" alt="" /> </span
              ><span class="calendar_title"> 至</span>
              <span @click="endClick">
                {{ endDate }} <img src="../assets/rl.png" alt=""
              /></span>
            </div>
            <button class="right" @click="OkClick()">确定</button>
          </div>
          <van-calendar
            v-model="startShow"
            @confirm="onStartConfirm"
            :show-confirm="false"
            :min-date="minDate"
            :max-date="maxDate"
            :default-date="stockdefaultDate"
          />
          <van-calendar
            v-model="endShow"
            @confirm="onEndConfirm"
            :min-date="minDate"
            :max-date="maxDate"
            :show-confirm="false"
            :default-date="enddefaultDate"
          />
          <div class="main-centent">
            <div class="todaySelected-title">
              <div style="width: 2.08rem">股票/时间</div>
              <div style="width: 1.8rem">成交价</div>
              <div style="width: 1.3rem">成交量</div>
              <div style="width: 1.65rem; text-align: right" @click="zfClick()">
                <span>成交额</span>
              </div>
            </div>
          </div>
          <van-pull-refresh v-model="isLoading" @refresh="onRefresh">
            <van-list v-model="loading" :finished="finished" @load="onLoad">
              <CJList
                v-if="active == 2 && list.length > 0"
                :list="list"
              ></CJList>
              <div v-else class="wushuju" v-show="show">
                <img src="../assets/wushuju.png" alt="" />
                <p>暂无数据</p>
              </div>
            </van-list>
          </van-pull-refresh>
        </van-tab>
      </van-tabs>
    </div>
  </div>
</template>

<script>
import NavBar from "@/components/NavBar.vue";
import CJList from "@/components/cjlist.vue";
import { getFormatDate, getDay } from "@/utils/time";
import api from "@/api/index";
import { Tab, Tabs, Calendar, Button, List, PullRefresh } from "vant";
export default {
  components: {
    CJList,
    NavBar,
    [Tab.name]: Tab,
    [Tabs.name]: Tabs,
    [Calendar.name]: Calendar,
    [Button.name]: Button,
    [List.name]: List,
    [PullRefresh.name]: PullRefresh,
  },
  data() {
    return {
      active: 0,
      startShow: false,
      endShow: false,
      startDate: "2020-01-03",
      endDate: "2020-01-03",
      minDate: new Date(1991, 0, 1),
      maxDate: new Date(),
      enddefaultDate: new Date(),
      stockdefaultDate: new Date(),
      list: [],
      userId: "",
      show: false,
      redate: "",
      page: 1,
      loading: false,
      finished: true,
      refreshing: false,
      isLoading: false,
      total: "",
    };
  },
  created() {
    this.userId = localStorage.getItem("userId");

    var date = getDay(-7);
    var nowDate = getDay(0);
    this.getList(date, nowDate);
  },

  methods: {
    onRefresh() {
      setTimeout(() => {
        this.isLoading = false;
        this.page = 1;
        this.list = [];
        this.redate = "";
        if (this.active == 0) {
          var date = getDay(-7);
          var nowDate = getDay(0);
        } else if (this.active == 1) {
          var date = getDay(-30);
          var nowDate = getDay(0);
        } else if (this.active == 2) {
          var date = this.startDate;
          var nowDate = this.endDate;
        }
        this.getList(date, nowDate);
      }, 1000);
    },
    onLoad() {
      // 异步更新数据
      // setTimeout 仅做示例，真实场景中一般为 ajax 请求
      setTimeout(() => {
        this.page++;
        // 加载状态结束
        // console.log(this.page);
        this.loading = false;
        if (this.active == 0) {
          var date = getDay(-7);
          var nowDate = getDay(0);
        } else if (this.active == 1) {
          var date = getDay(-30);
          var nowDate = getDay(0);
        } else if (this.active == 2) {
          var date = this.startDate;
          var nowDate = this.endDate;
        }
        this.getList(date, nowDate);
        // // 数据全部加载完成
        // if (this.list.length >= this.total) {
        //   this.finished = true;
        // }
      }, 1000);
    },
    onStartConfirm(date) {
      console.log(date);
      this.startShow = false;
      this.startDate = getFormatDate(date);
      console.log(this.startDate);
      let startDate = this.startDate.replace(/-/g, "/");
      this.stockdefaultDate = new Date(startDate);
    },
    onEndConfirm(date) {
      this.endShow = false;
      this.endDate = getFormatDate(date);
      let endDate = this.endDate.replace(/-/g, "/");
      this.enddefaultDate = new Date(endDate);
    },
    startClick() {
      this.startShow = true;
      console.log(this.startDate);
      let date = this.startDate.replace(/-/g, "/");
      this.stockdefaultDate = new Date(date);
    },
    endClick() {
      document.body.scrollTop = 0;
      this.endShow = true;
      let endDate = this.endDate.replace(/-/g, "/");
      this.enddefaultDate = new Date(endDate);
    },
    OkClick() {
      this.page = 1;
      this.list = [];
      this.redate = "";
      this.getList(this.startDate, this.endDate);
    },
    tabClick() {
      console.log(this.active);
      this.finished = true;
      this.redate = "";
      this.page = 1;
      this.list = [];
      if (this.active == 0) {
        var date = getDay(-7);
        var nowDate = getDay(0);
      } else if (this.active == 1) {
        var date = getDay(-30);
        var nowDate = getDay(0);
      } else if (this.active == 2) {
        this.startDate = getDay(-60);
        this.endDate = getDay(0);
        var date = getDay(-60);
        var nowDate = getDay(0);
      }

      this.getList(date, nowDate);
    },
    getList(date, nowDate) {
      let params = {
        analog_stock_account_id: this.userId,
        startDate: date,
        endDate: nowDate,
        page: this.page,
        pageSize: 20,
      };
      api.getStockDeal(params).then((res) => {
        console.log(res);
        if (res.code == 200) {
          var list = [];
          list = res.data.records;
          this.total = res.data.total;
          this.list = this.list.concat(list);
          if (this.list.length >= this.total) {
            this.finished = true;
          } else {
            this.finished = false;
          }
          if (this.list.length > 0) {
            this.show = false;
          } else {
            this.show = true;
          }
          for (var i = 0; i < this.list.length; i++) {
            if (this.redate != this.list[i].orderDate) {
              this.redate = this.list[i].orderDate;
              this.list[i].show = 1;
            }
          }
          console.log(this.list);
        }
      });
    },
  },
};
</script>
   
<style lang="less" scoped>
.content {
  height: 100vh;
  // overflow: hidden;
  background: #f5f5f5;
  padding-top: 0.87rem;
}

.calendar {
  background: #fff;
  height: 1rem;
  padding: 0.1rem 0.32rem 0 0.32rem;
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: 0.28rem;
  .left {
    display: flex;
    span {
      display: flex;
      align-items: center;

      color: #48546a;
      img {
        padding-left: 0.1rem;
        width: 0.14rem;
      }
    }
    .calendar_title {
      padding: 0 0.2rem;
    }
  }
  .right {
    width: 1.2rem;
    height: 0.52rem;
    background: #ec333b;
    border-radius: 0.04rem;
    color: #fff;
    display: flex;
    justify-content: center;
    align-items: center;
    border: 0;
    /deep/.van-button--normal {
      padding: 0;
    }
  }
}
.main-centent {
  padding: 0 0 0 0.32rem;
  background: #fff;
  margin-top: 0.2rem;
  border-bottom: 0.01rem solid rgba(237, 237, 237, 1);
}
.todaySelected-top {
  height: 0.5rem;
  font-size: 0.36rem;
  font-weight: bold;
  color: #333333;
  line-height: 0.5rem;
}
.todaySelected-title {
  height: 0.76rem;
  color: #666666;
  //   margin: 0 0 0 0.32rem;
  font-size: 0.24rem;

  display: flex;
  justify-content: initial;
  align-items: center;

  div:nth-child(4) {
    display: flex;
    justify-content: flex-end;
    align-items: center;
    img {
      width: 0.44rem;
      height: 0.44rem;
    }
  }
}
.wushuju {
  height: 4rem;
  background: #f5f5f5;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding-top: 1.7rem;
  img {
    height: 4rem;
    width: 4rem;
  }
}
</style>